export default {"src":"/_next/static/media/curved-arrow.22c11dad.svg","height":150,"width":141,"blurWidth":0,"blurHeight":0};